import React from "react";

function Boolean({ value }) {
  return value ? <span>OUI</span> : <span>NON</span>;
}

export default Boolean;
